import RecoverStep from "../recover_step";

const TEMPLATE = 'virtualization-failover-failed';

export default class CreateFailoverFailed extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep){
        const siteName = data.render.clientName;
        data.render  = {
            searchComplete: true,
            clientName: siteName
        };
        fr.render('createFailoverFailed');
    }

}
